import { ConnectAccountsCta } from "@components/billing/PlanManagement/ConnectAccountsCta";
import { useCanConnectIntegrations } from "@hooks/useCanConnectIntegrations";
import { EmptyState } from "@design-system/EmptyState/EmptyState";
import { FC } from "react";
import {
    BILL_CONNECT_CTA_SUBTITLE,
    BILL_CONNECT_CTA_TITLE,
    BillConnectButtons,
} from "./billConnectCta";

export type BillTableViewKind = "bills" | "lineItems" | "vendors";

type BillTableEmptyViewVariant =
    | "loading"
    | "filtered"
    | "connect"
    | "no-data"
    | "none";

const FILTER_EMPTY_HEADERS: Record<BillTableViewKind, string> = {
    bills: "The filters don't match any bills.",
    lineItems: "The filters don't match any line items.",
    vendors: "The filters don't match any vendors.",
};

const NO_DATA_HEADERS: Record<BillTableViewKind, string> = {
    bills: "No bills found",
    lineItems: "No line items found",
    vendors: "No vendor data found",
};

interface BillTableEmptyViewProps {
    variant: Exclude<BillTableEmptyViewVariant, "loading" | "none">;
    viewKind: BillTableViewKind;
    onClearFilters: () => void;
}

export const BillTableEmptyView: FC<BillTableEmptyViewProps> = ({
    variant,
    viewKind,
    onClearFilters,
}) => {
    const canConnectIntegrations = useCanConnectIntegrations();

    if (variant === "connect" && canConnectIntegrations) {
        return (
            <ConnectAccountsCta
                title={BILL_CONNECT_CTA_TITLE}
                subtitle={BILL_CONNECT_CTA_SUBTITLE}
            >
                <BillConnectButtons />
            </ConnectAccountsCta>
        );
    }

    if (variant === "filtered") {
        return (
            <EmptyState
                header={FILTER_EMPTY_HEADERS[viewKind]}
                action={onClearFilters}
            />
        );
    }

    return <EmptyState header={NO_DATA_HEADERS[viewKind]} />;
};
